export const toCamelCase = (str: string): string => {
    return str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
};

export const keysToCamelCase = (obj: any): any => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(keysToCamelCase);
    }

    const n: any = {};
    Object.keys(obj).forEach((k) => {
        n[toCamelCase(k)] = keysToCamelCase(obj[k]);
    });
    return n;
};
